// extracted by mini-css-extract-plugin
export default {"singleCardBlock":"SingleCardBlock_singleCardBlock__MX7Bi","heading":"SingleCardBlock_heading__3vG0i"};